<ui-modal
  title="Manage Recipe Images"
  size="lg"
  [showCloseButton]="true"
  [closeOnBackdrop]="true"
  (modalClosed)="close()">

  <div class="modal-body">
    @if (hasRecipeId) {
      <app-recipe-image-manager [recipeId]="recipeId!" [sourceUrl]="sourceUrl" />
    }
  </div>

</ui-modal>
